<ng-container>
  <nz-input-group>
    <div nz-row>
      <nz-input-number
        nz-col
        style="width: 100%"
        [ngModel]="value"
        [ngModelOptions]="{ standalone: true }"
        [nzDisabled]="disabled"
        [disabled]="disabled"
        (ngModelChange)="writeValue($event)"
        (blur)="onFieldBlur($event)"
      ></nz-input-number>
      <ng-content></ng-content>
    </div>
  </nz-input-group>
</ng-container>

<!--[nzSpan]="field.AdditionalData?.hasUom === true ? 16 : 24" -->